var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "avatar",
      class: _vm.shape === "circle" ? "shape-circle" : ""
    },
    [_c("img", { attrs: { src: _vm.avatarSrc } })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }